import { OPEN_CACHE_KEY, CLOSE_CACHE_KEY, RECON_CACHE_KEY, PROC_CACHE_KEY } from '../../component/PaymentStatusTileGroup/PaymentStatusTileGroup';
import { TOTAL_CACHE_KEY, WEEK_CACHE_KEY, MONTH_CACHE_KEY, QUARTER_CACHE_KEY, LAST_REFRESHED_TIME } from '../../component/ProgramOverviewTileGroup/ProgramOverviewTileGroup';
import { TRENDS_CACHE_KEY } from '../PaymentTrends/PaymentTrends';
import { useLocation } from "react-router-dom";

export function RefreshEvent() {
    let path = useLocation().pathname;

    window.onunload = (e) => {
        // clear out cached dashboard values on refresh
        if (path.includes('dashboard')) {
            // Program Overview
            window.sessionStorage.removeItem(OPEN_CACHE_KEY);
            window.sessionStorage.removeItem(CLOSE_CACHE_KEY);
            window.sessionStorage.removeItem(RECON_CACHE_KEY);
            window.sessionStorage.removeItem(PROC_CACHE_KEY);

            // Payment Trends 30 day All types graph
            window.sessionStorage.removeItem(TRENDS_CACHE_KEY);

            // Payments by Status tiles
            window.sessionStorage.removeItem(TOTAL_CACHE_KEY);
            window.sessionStorage.removeItem(WEEK_CACHE_KEY);
            window.sessionStorage.removeItem(MONTH_CACHE_KEY);
            window.sessionStorage.removeItem(QUARTER_CACHE_KEY);

            window.sessionStorage.removeItem(LAST_REFRESHED_TIME);
        }
    }

}